import BaseTheme from '../base';

export default {
  ...BaseTheme.Colors,
  interactionDark: 'rgb(0, 42, 77)',
  success: '#00A000'
};
